import { publishedPosts } from "./blog";

export const LOCAL_AREAS = [
  { slug: "golden-beach", name: "Golden Beach", to: "/golden-beach" },
  { slug: "caloundra", name: "Caloundra", to: "/caloundra" },
  { slug: "pelican-waters", name: "Pelican Waters", to: "/pelican-waters" },
] as const;

export function localReadingPosts() {
  return publishedPosts().filter((post) =>
    LOCAL_AREAS.some((area) => post.area.toLowerCase().includes(area.name.toLowerCase())) ||
    /sunshine coast|queensland/i.test(post.area),
  );
}